export default __webpack_public_path__ + "static/media/line-h-09.905f630d.png";